import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    Label,
    Row,
} from "reactstrap";

import Breadcrumbs from "components/Common/Breadcrumb";

import * as Yup from "yup";
import { useFormik } from "formik";
import CommonDialog from "components/Common/CommonDialog";
import ToastDialog from "components/Common/ToastDialog";

import { useToast } from "ToastStore";
import { addPromotion, editPromotion, getPromotion } from "helpers/UAM/promotion.helper";
import { formatDateString } from "common/utility";
import { SystemConfigurationContext } from "context/systemConfigContext";

const AddOrEditPromotion = () => {
    const [promotion, setPromotion] = useState({})
    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const navigate = useNavigate();
    const {inputMax} = useContext(SystemConfigurationContext)

    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)

    const { handleToastData } = useToast();

    document.title = encodedId ? "Edit Promocode | DMS" : "Add Promocode | DMS"

    useEffect(() => {
        if (encodedId) {
            getPromotion({ id: decodedId })
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 200) {
                        let responseData = responseFromAPI.data;
                        responseData.startDate = formatDateString(
                            responseData.startDate
                        );
                        responseData.endDate = formatDateString(
                            responseData.endDate
                        );
                        setPromotion(responseData)
                    }
                })
                .catch(error => { })
        }
    }, [])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            promotionCode: promotion.promotionCode || "",
            description: promotion.description || "",
            startDate: promotion.startDate || "",
            endDate: promotion.endDate || "",
            discount: promotion.discount || "",
            depot: promotion.depot || ""
        },

        validationSchema: Yup.object({
            promotionCode: Yup.string().required("Please Enter Promotion code"),
            description: Yup.string().required("Please Enter Description"),
            startDate: Yup.string().required("Please Enter Promotion Start Date "),
            endDate: Yup.string().required("Please Enter Promotion End Date "),
            discount: Yup.number().required("Please Enter Discount"),
            depot: Yup.string()
        }),

        onSubmit: (values) => {
            const message = encodedId ? 'Are you sure want to edit promocode?' : 'Do you want to save entry?'
            setShowCommonDialog({ isShow: true, message })
        }
    });

    const handleCancel = () => {
        navigate(-1)
    }

    const submitPromotion = () => {
        const { values } = validation
        const { roleName } = JSON.parse(localStorage.getItem("user"))
        const promocodeData = {
            promotionCode: values.promotionCode,
            description: values.description,
            startDate: values.startDate,
            endDate: values.endDate,
            discount: values.discount,
            depot: values.depot,
        }
        if (encodedId) {
            promocodeData['id'] = decodedId;
            editPromotion(promocodeData)
                .then(responseFromAPI => {
                    if (responseFromAPI.status) {
                        
                        handleToastData(`${promocodeData.promotionCode} ${responseFromAPI.message}`, "warning")
                        validation.resetForm()
                        navigate(`/${roleName}/promotionList`);

                    } else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
        } else {
            addPromotion(promocodeData)
                .then(responseFromAPI => {
                    if (responseFromAPI.status) {
                        handleToastData(`${promocodeData.promotionCode} ${responseFromAPI.message}`, "success")
                        validation.resetForm()
                        navigate(`/${roleName}/promotionList`);
                    } else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
        }

    }

    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
            submitPromotion()
        } else {
            setShowCommonDialog({ isShow: false })
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Breadcrumbs title="Promocode" breadcrumbItem={encodedId ? "Edit Promocode" : "Add Promocode"} />
                <Container fluid className="vertical-scroll">
                    <Card>
                        <CardBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Promotion Code*</Label>
                                        <Input
                                            name="promotionCode"
                                            type="text"
                                            placeholder="Enter Promotion Code"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.promotionCode || ""}
                                            invalid={
                                                validation.touched.promotionCode &&
                                                validation.errors.promotionCode
                                            }
                                            maxLength={inputMax}
                                        />
                                        {validation.touched.promotionCode &&
                                            validation.errors.promotionCode ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.promotionCode}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    {/* <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Depot Name*</Label>
                                        <Input
                                            name="depot"
                                            type="select"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.depot || ""}
                                            invalid={validation.touched.depot && validation.errors.depot ? true : false}
                                        >
                                            <option value="" disabled>Select an Depot</option>
                                            <option value="Western Depot">Western Depot</option>
                                            <option value="Eastern Distribution Center">Eastern Distribution Center</option>
                                            <option value="Southern Warehouse">Southern Warehouse</option>
                                            <option value="Northern Depot">Northern Depot</option>
                                            <option value="Central Depot">Central Depot</option>

                                        </Input>
                                        {validation.touched.depot && validation.errors.depot ? (
                                            <FormFeedback type="invalid">{validation.errors.depot}</FormFeedback>
                                        ) : null}
                                    </Col> */}

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Start Date*</Label>
                                        <Input
                                            name="startDate"
                                            type="date"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.startDate || ""}
                                            invalid={
                                                validation.touched.startDate && validation.errors.startDate ? true : false
                                            }
                                        />
                                        {validation.touched.startDate && validation.errors.startDate ? (
                                            <FormFeedback type="invalid">{validation.errors.startDate}</FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">End Date*</Label>
                                        <Input
                                            name="endDate"
                                            type="date"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.endDate || ""}
                                            invalid={
                                                validation.touched.endDate && validation.errors.endDate ? true : false
                                            }
                                        />
                                        {validation.touched.endDate && validation.errors.endDate ? (
                                            <FormFeedback type="invalid">{validation.errors.endDate}</FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Discount(%)*</Label>
                                        <Input
                                            name="discount"
                                            type="number"
                                            placeholder="Enter Discount "
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.discount || ""}
                                            invalid={
                                                validation.touched.discount &&
                                                validation.errors.discount
                                            }
                                        />
                                        {validation.touched.discount &&
                                            validation.errors.discount ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.discount}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Description*</Label>
                                        <Input
                                            maxLength={inputMax}
                                            name="description"
                                            type="textarea"
                                            placeholder="Enter Promocode Description"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.description || ""}
                                            invalid={
                                                validation.touched.description &&
                                                validation.errors.description
                                            }
                                        />
                                        {validation.touched.description &&
                                            validation.errors.description ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.description}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>
                                </Row>
                                <Col className="mt-4">
                                    <div className="d-flex gap-3 justify-content-end">
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success save-customer"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Col>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
            {
                showCommonDialog &&
                <CommonDialog
                    isShow={showCommonDialog.isShow}
                    message={showCommonDialog.message} data={showCommonDialog.data}
                    postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}
                />
            }
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </React.Fragment>

    )
}

export default AddOrEditPromotion